export type ScrapedChange = {
    key: string,
    label: string,
    current: string,
    scraped: string,
    protected: boolean,
    unmatched: string[]
};

export type ScrapedCompanyItem = {
    tenantId: number,
    name: string,
    orgNumber: string,
    isAccepted: boolean,
    detailScrapedAt: string | null,
    scrapedAt: string | null,
    status: string | null,
    lastError: string | null,
    changes: ScrapedChange[]
};

export function formatChange(change: ScrapedChange): string {
    const current = change.current || '–';
    const scraped = change.scraped || '–';
    const protectedSuffix = change.protected ? ' (ändrad av användaren)' : '';
    const unmatchedSuffix = change.unmatched.length
        ? ` ${change.unmatched.join(', ')} (finns inte i katalogen)`
        : '';
    return `${change.label}: ${current} → ${scraped}${protectedSuffix}${unmatchedSuffix}`;
}

export function jobLabel(item: { status: string | null, lastError: string | null }): string | null {
    if (item.status === 'pending') {
        return 'Köad';
    }
    if (item.status === 'running') {
        return 'Pågår';
    }
    if (item.status === 'failed') {
        return item.lastError ? `Misslyckades: ${item.lastError}` : 'Misslyckades';
    }
    return null;
}
